module.exports = __webpack_public_path__ + "img/logoBlue.3d45c151.png";